import { CONSTANT } from "src/app/constant";

export interface RemoteSignoffSendRow {
	trainerSignature?: unknown;
	trainerName?: string;
	instructorLicenseNumber?: string;
	category?: string | null;
	finalRating?: number | null;
}

function isCabinCrewFormType(formType?: string): boolean {
	return formType === CONSTANT.FORM_TYPE.cabin_crew || formType === CONSTANT.FORM_TYPE.cabin_crew_instructor;
}

/**
 * Instructor send gate aligned with backend `assertSignOffReadyForRemoteSend`.
 * Cabin requires a final rating and does not use a license number.
 * ETS-3 and TS-1 require a sign-off category. TS-1 also keeps the license field
 * the existing instructor send payload checks.
 */
export function canSendRemoteSignoff(formType: string | undefined, rows: RemoteSignoffSendRow[]): boolean {
	if (!rows.length) return false;

	const instructor = rows[0];
	if (!instructor?.trainerSignature || !String(instructor.trainerName ?? "").trim()) {
		return false;
	}

	if (isCabinCrewFormType(formType)) {
		return instructor.finalRating != null && Number(instructor.finalRating) > 0;
	}

	if (!String(instructor.category ?? "").trim()) {
		return false;
	}

	if (formType === CONSTANT.FORM_TYPE.ts_1) {
		return !!String(instructor.instructorLicenseNumber ?? "").trim();
	}

	return true;
}
